import script from "./OidoHelpIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoHelpIcon.vue?vue&type=script&setup=true&lang=js"

import "./OidoHelpIcon.vue?vue&type=style&index=0&id=a991d212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a991d212"]])

export default __exports__